import * as Types from '../types.generated'

import { gql } from '@apollo/client'
import { ProjectDetailsFragmentDoc } from '../fragments/ProjectDetails.generated'
import { ProjectsListFragmentDoc } from '../fragments/ProjectsList.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export const GetPaginatedProjectsFromFirstFragmentDoc = gql`
  fragment getPaginatedProjectsFromFirst on Query {
    fromFirst: projects(first: $limit, after: $cursor, text: $text, frameworks: $frameworks) {
      ...ProjectsList
    }
  }
  ${ProjectsListFragmentDoc}
`
export const GetPaginatedProjectsFromLastFragmentDoc = gql`
  fragment getPaginatedProjectsFromLast on Query {
    fromLast: projects(last: $limit, before: $cursor, text: $text, frameworks: $frameworks) {
      ...ProjectsList
    }
  }
  ${ProjectsListFragmentDoc}
`
export const GetProjectBySlugDocument = gql`
  query GetProjectBySlug($slug: String!) {
    project(slug: $slug) {
      ...ProjectDetails
    }
  }
  ${ProjectDetailsFragmentDoc}
`

/**
 * __useGetProjectBySlugQuery__
 *
 * To run a query within a React component, call `useGetProjectBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetProjectBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetProjectBySlugQuery, GetProjectBySlugQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProjectBySlugQuery, GetProjectBySlugQueryVariables>(GetProjectBySlugDocument, options)
}
export function useGetProjectBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectBySlugQuery, GetProjectBySlugQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProjectBySlugQuery, GetProjectBySlugQueryVariables>(GetProjectBySlugDocument, options)
}
export type GetProjectBySlugQueryHookResult = ReturnType<typeof useGetProjectBySlugQuery>
export type GetProjectBySlugLazyQueryHookResult = ReturnType<typeof useGetProjectBySlugLazyQuery>
export type GetProjectBySlugQueryResult = Apollo.QueryResult<GetProjectBySlugQuery, GetProjectBySlugQueryVariables>
export const GetPaginatedProjectsDocument = gql`
  query getPaginatedProjects($limit: Int, $cursor: Cursor, $text: String, $frameworks: [String!], $isFromFirst: Boolean!) {
    ...getPaginatedProjectsFromFirst @include(if: $isFromFirst)
    ...getPaginatedProjectsFromLast @skip(if: $isFromFirst)
  }
  ${GetPaginatedProjectsFromFirstFragmentDoc}
  ${GetPaginatedProjectsFromLastFragmentDoc}
`

/**
 * __useGetPaginatedProjectsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      text: // value for 'text'
 *      frameworks: // value for 'frameworks'
 *      isFromFirst: // value for 'isFromFirst'
 *   },
 * });
 */
export function useGetPaginatedProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedProjectsQuery, GetPaginatedProjectsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaginatedProjectsQuery, GetPaginatedProjectsQueryVariables>(GetPaginatedProjectsDocument, options)
}
export function useGetPaginatedProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedProjectsQuery, GetPaginatedProjectsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPaginatedProjectsQuery, GetPaginatedProjectsQueryVariables>(GetPaginatedProjectsDocument, options)
}
export type GetPaginatedProjectsQueryHookResult = ReturnType<typeof useGetPaginatedProjectsQuery>
export type GetPaginatedProjectsLazyQueryHookResult = ReturnType<typeof useGetPaginatedProjectsLazyQuery>
export type GetPaginatedProjectsQueryResult = Apollo.QueryResult<GetPaginatedProjectsQuery, GetPaginatedProjectsQueryVariables>
export type GetProjectBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']
}>

export type GetProjectBySlugQuery = {
  __typename?: 'Query'
  project?: {
    __typename?: 'Project'
    id: string
    name: string
    description: string
    type: Types.ProjectType
    slug: string
    explorerApiUrl: string
    frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
    logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
    socialUrls: Array<{ __typename?: 'SocialURL'; type: Types.SocialUrlType; url: string }>
  } | null
}

export type GetPaginatedProjectsFromFirstFragment = {
  __typename?: 'Query'
  fromFirst: {
    __typename?: 'ProjectConnection'
    edges: Array<{
      __typename?: 'ProjectEdge'
      cursor: any
      node: {
        __typename?: 'Project'
        id: string
        name: string
        descriptionExcerpt: string
        type: Types.ProjectType
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}

export type GetPaginatedProjectsFromLastFragment = {
  __typename?: 'Query'
  fromLast: {
    __typename?: 'ProjectConnection'
    edges: Array<{
      __typename?: 'ProjectEdge'
      cursor: any
      node: {
        __typename?: 'Project'
        id: string
        name: string
        descriptionExcerpt: string
        type: Types.ProjectType
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}

export type GetPaginatedProjectsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>
  cursor?: Types.InputMaybe<Types.Scalars['Cursor']>
  text?: Types.InputMaybe<Types.Scalars['String']>
  frameworks?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>
  isFromFirst: Types.Scalars['Boolean']
}>

export type GetPaginatedProjectsQuery = {
  __typename?: 'Query'
  fromFirst: {
    __typename?: 'ProjectConnection'
    edges: Array<{
      __typename?: 'ProjectEdge'
      cursor: any
      node: {
        __typename?: 'Project'
        id: string
        name: string
        descriptionExcerpt: string
        type: Types.ProjectType
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
  fromLast: {
    __typename?: 'ProjectConnection'
    edges: Array<{
      __typename?: 'ProjectEdge'
      cursor: any
      node: {
        __typename?: 'Project'
        id: string
        name: string
        descriptionExcerpt: string
        type: Types.ProjectType
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}
